import { render } from "./modalTipCoach.vue?vue&type=template&id=780b4408&scoped=true"
import script from "./modalTipCoach.vue?vue&type=script&lang=js"
export * from "./modalTipCoach.vue?vue&type=script&lang=js"

import "./modalTipCoach.vue?vue&type=style&index=0&id=780b4408&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780b4408"]])

export default __exports__